import React, { useEffect, useRef, useState } from 'react';
import { Dialog, TextField, Button } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import DataTable from '../../../../../components/DataTable/DataTable';
import OperationService from '../../../../../services/OperationService/OperationService';
import Search from '../../../../../components/Search/Search';

function AllProcesses(props) {

    const label = 'CONTENT.DASHBOARD.';
    // Initial state
    const custom = useRef();
    const { t } = useTranslation();
    const [searchData, setSearchData] = useState([]);
    const data = useRef([]);
    const [loading, setLoading] = useState(true);

    // Fetch data on start
    useEffect(() => {
        let today = new Date();
        let week = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        fetchData(week.toISOString(), today.toISOString());
    }, []);

    // Fetch Activity Center data
    const fetchData = async (startDate = '', endDate = '') => {
        const res = await OperationService.getOperation(startDate, endDate, 'automation');
        // Update state value
        if (res?.status) {
            data.current = res.data;
            setSearchData(res.data);
        }
        setLoading(false);
    };
    const handleClick = (e) => {
        let target = e.target;
        let value = target.value;
        for (const el of target.parentNode.childNodes) {
            el.classList.remove('db-tabactive');
        }
        target.classList.add('db-tabactive');
        if (value === 'custom') {
            custom.current.style.display = 'block';
            return;
        }
        else { custom.current.style.display = 'none'; }
        let today = new Date();
        let date = today;
        // Week is selected
        if (value === 'week') {
            date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
            // Month is selected
        } else if (value === 'month') {
            date = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
            // Year is selected
        } else if (value === 'year') {
            date = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
        }
        // Update state value
        fetchData(date.toISOString(), today.toISOString());
    };
    const handleClose = () => { props.setOpen(false); };
    // Handle custom date filter
    const handleSubmit = (e) => {
        e.preventDefault();
        fetchData(e.target[0].value, e.target[1].value);
    }
    const customColumn = [{
        name: 'empty', label: ' ',
        options: { filter: false, sort: false, display: true }
    }, {
        name: 'id', label: ' ',
        options: {
            filter: false, sort: false, customBodyRenderLite: (dataIndex, rowIndex) => {
                if (data && data[dataIndex]) { return <span>{dataIndex + 1}</span>; }
            }
        }
    }, {
        name: 'name', label: t(label + 'BOT'), options: { filter: true, sort: true }
    }, {
        name: 'timeElapsed', label: t(label + 'TIME-ELAPSED'),
        options: { filter: true, sort: true }
    }, {
        name: 'completedAt', label: t(label + 'LAST-ACTIVITY'),
        options: {
            filter: true, sort: true, customBodyRenderLite: (dataIndex, rowIndex) => {
                if (searchData[dataIndex]) {
                    return new Date(searchData[dataIndex].completedAt).toLocaleString(t('CONTENT.CREDENTIAL-TAB.LOCALE'));
                }
            }
        }
    }];
    return (
        <Dialog open={true} onClose={handleClose} fullWidth={true} maxWidth="md">
            <div style={{ display: 'flex', padding: '10px 10px 0px 10px' }}>
                <Search data={data.current} setSearchData={setSearchData} searchKey={['name', 'timeElapsed', 'complatedAt']} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                    label={<span className="db-label" style={{ whiteSpace: 'nowrap', margin: '9px 0 0 20px' }}>{t(label + 'ACTIVITY-CENTER')}</span>}
                >
                    <div style={{ margin: '6px 15px auto auto', textAlign: 'right', position: 'relative' }}>
                        <div className="db-tabs db-page">
                            <button className="db-tabactive" value="week" onClick={handleClick}>
                                {t(label + 'WEEK')}
                            </button>
                            <button value="month" onClick={handleClick}>
                                {t(label + 'MONTH')}
                            </button>
                            <button value="year" onClick={handleClick}>
                                {t(label + 'YEAR')}
                            </button>
                            <button value="custom" onClick={handleClick}>
                                {t(label + 'CUSTOM')}
                            </button>
                        </div>
                        <form onSubmit={handleSubmit} ref={custom} className="db-page" style={{ position: 'absolute', marginTop: 5, right: 0, zIndex: 101, padding: 5, textAlign: 'right', display: 'none' }}>
                            <div style={{ marginBottom: 5 }}><TextField type="datetime-local" /></div>
                            <div style={{ marginBottom: 5 }}><TextField type="datetime-local" /></div>
                            <Button type="submit" style={{ backgroundColor: '#6b6b6b', color: '#fff' }}>{t(label + 'FILTERS')}</Button>
                        </form>
                    </div>
                </Search>
            </div>
            <div className="db-scroll" style={{ height: '60vh', overflow: 'auto' }}>
                <DataTable
                    customColumns={customColumn}
                    selectableRows="none"
                    data={searchData} title=""
                    filter={false} download={false}
                    viewColumns={false} print={false}
                    loading={loading}
                />
            </div>
        </Dialog>
    );
}
export default AllProcesses;
